export enum PageNames {
  MAP = 'MAP',
  PLANNING = 'PLANNING',
  REPORTS = 'REPORTS'
}
